import {TicketMessageDto, TicketMessageEntity, ticketMessageEntityToTicketMessageDto} from './ticket-message.types';

export enum TicketStatus {
    PENDING_USER = 'PENDING_USER',
    PENDING_ADMIN = 'PENDING_ADMIN',
    SOLVED = 'SOLVED',
    REJECTED = 'REJECTED'
}


export enum TicketIncidentType {
    CARD = "CARD",
    IBAN = "IBAN",
    INCIDENT = "INCIDENT",
}

export type TicketEntity = {
    id: number,
    userId: number,
    title: string,
    status: TicketStatus,
    createdDate: Date,
    modifiedDate: Date,
    incidentType: TicketIncidentType,
    isRead: boolean,
    isSuccess: boolean,
    ticketMessages: Array<TicketMessageEntity>
    ticketAttachments: Array<TicketAttachmentEntity>,
    user: any
}

export enum SearchListType {
    MESSAGE_LIST = 'MESSAGE_LIST',
    TOPIC_LIST = 'TOPIC_LIST'
}

export type TicketSimpleDto = Omit<TicketEntity, 'ticketMessages' | 'ticketAttachments' | 'user' | 'incidentType'> & {
    lastMessage: TicketMessageDto
}

export function ticketEntityToTicketSimpleDto($: TicketEntity): TicketSimpleDto {
    const lastMessage = $.ticketMessages.sort(
        (a, b) => b.createdDate.getTime() - a.createdDate.getTime())[0];
    const ticket = {
        ...$,
        lastMessage: ticketMessageEntityToTicketMessageDto(lastMessage, $.userId)
    };

    delete ticket.ticketAttachments;
    delete ticket.ticketMessages;
    delete ticket.user;

    return ticket;
}

export type TicketDto = Omit<TicketEntity, 'ticketAttachments' | 'user' | 'incidentType' | 'ticketMessages'> & {
    ticketMessages: ReadonlyArray<TicketMessageDto>
}

export function ticketEntityToTicketDto($: TicketEntity): TicketDto {
    const ticket = {
        ...$,
        ticketMessages: $.ticketMessages.map(($message) => ticketMessageEntityToTicketMessageDto($message, $.userId))
    };

    delete ticket.ticketAttachments;
    delete ticket.user;

    return ticket;
}

export type SearchTicketsType = {
    type: SearchListType,
    list: Array<TicketSimpleDto>
}

export type TicketAttachmentEntity = {
    ticketMessageId: number;
    createdDate: Date;
    ticketId: number;
    mimetype: string;
    name: string;
    size: string;
    key: string;
    id: number;
};

export type DownloadAttachmentData = {
    ticketAttachment: TicketAttachmentEntity,
    file: Buffer
}


